export default {
  name: "badge",
  class: `h-2 w-2`,
  box: 8,
  svg: `<path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" stroke="fillcolor"/>`,
};
